import { render, staticRenderFns } from "./TrendManage.vue?vue&type=template&id=301df6c4&scoped=true"
import script from "./TrendManage.vue?vue&type=script&lang=js"
export * from "./TrendManage.vue?vue&type=script&lang=js"
import style0 from "./TrendManage.vue?vue&type=style&index=0&id=301df6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301df6c4",
  null
  
)

export default component.exports